import { type ReactNode, useEffect, useState } from 'react';

import { InactivityTimer } from '@nesso/ui/lib/inactivity-timer';
import { InactivityTimerContext } from '@nesso/ui/providers/inactivity-timer-provider';

import { subscribeToRecordingActive } from '@/shared/lib/cross-tab-recording-signal';

export function InactivityTimerProvider({ children }: { children: ReactNode }) {
    const [inactivityTimer] = useState(new InactivityTimer());

    useEffect(() => {
        inactivityTimer.init();
        return () => inactivityTimer.destroy();
    }, [inactivityTimer]);

    useEffect(() => {
        return subscribeToRecordingActive((active) => {
            if (active) {
                inactivityTimer.stop();
            } else {
                inactivityTimer.start();
            }
        });
    }, [inactivityTimer]);

    return <InactivityTimerContext value={inactivityTimer}>{children}</InactivityTimerContext>;
}

export { useInactivityTimer } from '@nesso/ui/providers/inactivity-timer-provider';
